import { createReducer } from '@reduxjs/toolkit'
import { PromoGroup } from 'interfaces/api/promoGroups.interfaces'
import { ValidationErrorsApi } from 'packages/api'
import { createBuilder } from 'packages/redux-toolkit'

import {
  createPromoGroup,
  getAllPromoGroups,
  removePromoGroup,
  setPromoGroupValidationErrors,
  setSinglePromoGroup,
  updatePromoGroup,
} from './actions'

interface PromoGroupsState {
  list: {
    loading: boolean
    items: PromoGroup[]
  }
  single: {
    loading: boolean
    item: PromoGroup | null
  }
  validation: ValidationErrorsApi | null
}

const initialState: PromoGroupsState = {
  list: {
    loading: false,
    items: [],
  },
  single: {
    loading: false,
    item: null,
  },
  validation: null,
}

export const promoGroupsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllPromoGroups.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllPromoGroups.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllPromoGroups.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload
    })

    .addCase(setPromoGroupValidationErrors, (state, { payload }) => {
      state.validation = payload
    })

    .addCase([setSinglePromoGroup], (state, { payload }) => {
      state.single.loading = false
      state.single.item = payload
    })

    .addCase([createPromoGroup.pending, removePromoGroup.pending, updatePromoGroup.pending], (state) => {
      state.single.loading = true
    })
    .addCase([createPromoGroup.rejected, removePromoGroup.rejected, updatePromoGroup.rejected], (state) => {
      state.single.loading = false
    })
    .addCase([createPromoGroup.fulfilled, removePromoGroup.fulfilled, updatePromoGroup.fulfilled], (state) => {
      state.single.loading = false
    })
})
